import { Link } from 'react-router-dom';

export default function SafetySection() {
  return (
    <section id="safety" className="bg-background-50 py-16 md:py-24">
      <div className="px-6 md:px-10">
        <div className="max-w-7xl mx-auto">
          <div className="flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
            {/* Image */}
            <div className="flex-1 w-full">
              <div className="rounded-2xl overflow-hidden aspect-[4/3] w-full">
                <img
                  src="https://readdy.ai/api/search-image?query=Close%20up%20of%20person%20in%20modern%20white%20office%20carefully%20examining%20a%20packaged%20product%20with%20checklist%20and%20tablet%20nearby%20soft%20diffused%20natural%20light%20from%20large%20window%20creating%20calm%20professional%20atmosphere%20focus%20on%20quality%20control%20and%20attention%20to%20detail%20European%20editorial%20photography%20with%20clean%20composition%20and%20warm%20neutral%20tones&width=900&height=675&seq=safety-section-v3&orientation=landscape"
                  alt="Quality inspection and safe shopping with VigorBuy Spreadsheet"
                  title="VigorBuy Safety - Quality Control and Seller Verification"
                  className="w-full h-full object-cover object-top"
                  loading="lazy"
                />
              </div>
            </div>

            {/* Content */}
            <div className="flex-1">
              <span className="inline-block px-3 py-1 text-xs font-medium text-accent-700 border border-accent-200 rounded-full whitespace-nowrap">
                Safety First
              </span>
              <h2 className="mt-4 text-3xl md:text-4xl font-heading font-bold text-foreground-950 leading-tight">
                Shop Smarter and Safer
              </h2>
              <p className="mt-4 text-base text-foreground-600 leading-relaxed">
                When using the VigorBuy Spreadsheet, your safety is our priority. Learn quality control, shipping protection, seller verification, and product inspection before ordering. Our guides walk you through every step of the international shopping journey.
              </p>
              <ul className="mt-6 space-y-3">
                {[
                  'Verify seller ratings and transaction history',
                  'Check product quality through detailed inspection guides',
                  'Protect your shipment with insurance and tracking',
                  'Learn how to spot counterfeit products',
                  'Understand return and refund policies',
                ].map((item) => (
                  <li key={item} className="flex items-start gap-3">
                    <span className="w-5 h-5 flex items-center justify-center flex-shrink-0 mt-0.5">
                      <i className="ri-shield-check-line text-primary-600"></i>
                    </span>
                    <span className="text-sm text-foreground-700">{item}</span>
                  </li>
                ))}
              </ul>
              <Link
                to="/article/is-vigorbuy-safe-review"
                className="inline-flex items-center gap-2 mt-8 px-6 py-3 text-sm font-semibold bg-primary-500 text-background-50 rounded-lg hover:bg-primary-600 transition-colors whitespace-nowrap"
              >
                Read Safety Review <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}